import { service } from '@maia/cart';
import { queryOptions } from '@tanstack/react-query';

export function getQuestionsOptions(
  params: Parameters<typeof service.getQuestions>[number],
) {
  return queryOptions({
    queryFn: () => service.getQuestions(params),
    queryKey: [
      'getQuestions',
      params.customerGuid,
      params.cartGuid,
      params.productGuid,
    ],
  });
}
